import { compose, withProps } from 'recompose'
import withType from 'components/common/hoc/withType'
import viewModel from './viewModel'
import BOTSearchTrailerTiresResult from './components/BOTSearchTrailerTiresResult'

export default compose(
  withType({ type: 'BOTSearchTrailerTiresResult' }),
  withProps({ viewModel })
)(BOTSearchTrailerTiresResult)
